import EventEmitter from '../event-emitter'
import messageParse from './parse'

// import { captureMessage } from '@sentry/browser'

const NOP_INTERVAL = 1000 * 30

// const log = (msg, ...args) => {
//   console.log(...[`[WebSocket] ${msg}`, ...args])
// }

export default class WebSocketWrapper {
	eventEmitter = new EventEmitter()

	set url(url) {
		this._url = url
	}

	get url() {
		return this._url
	}

	set socket(value) {
		this._ws = value
	}

	get socket() {
		return this._ws
	}

	get isLive() {
		return (this.socket && this.socket.readyState === 1) || false
	}

	get hasListeners() {
		return this.eventEmitter.hasListeners
	}

	onOpen = () => {
		const nop = () => {
			setTimeout(() => {
				if (!this.isLive) {
					return
				}
				this.socket.send(JSON.stringify({ command: 'NOP' }))
				nop()
			}, NOP_INTERVAL)
		}

		nop()
	}

	onClose = (..._args) => {
		if (!this._on) {
			return
		}

		setTimeout(() => this.connect(), 2000)
	}

	connect = () => {
		const { url } = this

		this._on = true

		return new Promise((resolve, reject) => {
			if (this.isLive) {
				return resolve()
			}

			if (!url) {
				return reject('can not connect, missing url')
			}

			try {
				const ws = new WebSocket(this.url)

				ws.onmessage = this.onMessage
				ws.onclose = this.onClose

				ws.onopen = () => {
					resolve()
					this.onOpen()
				}

				this.socket = ws
			} catch (e) {
				reject('Creating a `WebSoket` instance failed', e)
			}
		})
	}

	disconnect() {
		const { socket } = this

		this._on = false

		socket?.close()
	}

	canDisconnect() {
		return !this.hasListeners
	}

	on = (...args) => {
		this.connect()

		return this.eventEmitter.on(...args)
	}

	off = (...args) => {
		this.eventEmitter.off(...args)

		// if (!this.hasListeners) {
		//   this.disconnect()
		// }
	}

	onMessage = (res) => {
		const message = messageParse(res.data)

		if (!message) {
			return
		}

		console.log('[WebSocket] message:', message)

		const { ns, ...rest } = message
		const event = { event: ns, ns, ...rest }

		this.eventEmitter.emit(event)
	}
}
